import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
    date: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    active: PropTypes.bool,
};
const defaultProps = {
    active: false,
};

const TimeLineItem = ({
 date, eventName, active, ...props
}) => {
    const classes = classNames({
        'TimeLine__list-item': true,
        '-active': active,
    });
    return (
        <li className={classes} {...props}>
            <p className="TimeLine__event">
                <span className="h5">{date}</span>
{' '}
{eventName}
            </p>
        </li>
    );
};

TimeLineItem.propTypes = propTypes;
TimeLineItem.defaultProps = defaultProps;

export default TimeLineItem;
